<template>
  <button
    v-if="!fieldValue"
    type="button"
    @click="handleClickOpenDialogReferal"
  >
    <icon class="icon-click" name="clickMe" />{{ field.config.placeHolder }}
  </button>
  <p v-else class="valid">
    <icon name="goodAnswer" />{{
      `${field.config.validCodeMessage} : ${fieldValue}`
    }}
  </p>
</template>
<script setup lang="ts">
import FormFieldReferalCodeVerify from './FormFieldReferalCodeVerify.vue';
interface Props {
  field: FormField;
}
const props = defineProps({
  field: null
});
const dialog = useDialogStore();

const {
  formFieldsData: { memberValues },
} = inject(INJECT_FORM_PAGE);

const fieldValue = computed({
  get() {
    return memberValues.value[props.field.name].value;
  },
  set(value) {
    memberValues.value[props.field.name].value = value;
  },
});

const handleValidate = (code: string) => {
  fieldValue.value = code;
};
const handleClickOpenDialogReferal = () => {
  dialog.open(FormFieldReferalCodeVerify, {
    level: DialogLevel.Info,
    closeClickOutside: true,
    ...props.field.config,
    onValid: (code) => {
      handleValidate(code);
      dialog.close();
    },
  });
};
</script>
<style lang="scss" scoped>
.valid {
  @include font('m', 800);

  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--gap_xs);
  color: var(--color_success);
  text-align: center;
  .icon {
    border: solid var(--color_success) var(--stroke_thickness_l);
    border-radius: 50%;
  }
}
.valid,
button {
  padding: 2rem 0;
}
button {
  @include font('m', 800, 'secondary');

  display: block;
  width: 100%;
  color: var(--color_primary);
  .icon-click {
    margin-right: 1.4rem;
    transition: transform 400ms $ease-out-back;
  }
  &:hover,
  &:focus {
    text-decoration: underline;
    .icon-click {
      transform: translateX(1rem);
    }
  }
}
</style>
